import { EnvironmentUrls } from 'Roblox';
import { httpService } from '../../http/http';
import { ExperienceInviteData, FriendInviteData, ShareLinksType } from './shareLinksTypes';

const ResolveShareLinksUrlConfig = {
  url: `${EnvironmentUrls.shareLinksApi}/v1/resolve-link`,
  withCredentials: true
};

export type ResolveShareLinksResponse = {
  data?: {
    experienceInviteData?: ExperienceInviteData;
    friendInviteData?: FriendInviteData;
  };
};

const resolveShareLinks = (
  linkId: string,
  linkType: ShareLinksType
): Promise<ResolveShareLinksResponse> => {
  return httpService
    .post(ResolveShareLinksUrlConfig, {
      linkId,
      linkType
    })
    .then((response: ResolveShareLinksResponse) => {
      return response;
    });
};

export default resolveShareLinks;
